import type { SlackChannel, SlackStageResponse, SlackSubscription } from "../api/hooks/useSlack";

// The caveats an operator needs beside a channel's name.
export const channelNotes = (channel: SlackChannel): string[] =>
  [
    channel.is_private ? "private" : "",
    channel.is_ext_shared ? "shared with another organisation" : "",
    !channel.bot_is_member ? "not syncing: the bot is not in the channel" : "",
    channel.bot_is_member && !channel.backfill_complete ? "importing history" : "",
    channel.last_sync_status && !["ok", "not_in_channel"].includes(channel.last_sync_status)
      ? `last sync: ${channel.last_sync_error ?? channel.last_sync_status}`
      : "",
  ].filter(Boolean);

export const scopeLabel = (sub: SlackSubscription): string =>
  [
    sub.tenant_scope ? `tenant ${sub.tenant_scope}` : "",
    sub.landlord_scope ? `landlord ${sub.landlord_scope}` : "",
  ]
    .filter(Boolean)
    .join(" and ");

// The picker's empty option: what the list is doing when it has nothing to choose.
export const pickerPlaceholder = (available: number, checking: boolean): string =>
  available > 0 ? "Choose a channel" : checking ? "Checking Slack..." : "No channels to add";

// The sync to show progress for: the one this card staged, else one already running.
export const syncToShow = (
  staged: SlackStageResponse | null,
  activeKey: string | null | undefined,
): SlackStageResponse | null =>
  staged ?? (activeKey ? { operation_key: activeKey, skip_reason: null } : null);
